export default __webpack_public_path__ + "static/media/backButton.4d0bec2c.svg";